/**
 * Sentinel for a `/area/$areaId` path param that fails `AreaIdSchema`.
 *
 * Sibling of `sector/invalid-sector-param-error.ts`. TanStack Router's
 * CatchBoundary routes BOTH `params.parse` failures and render-time exceptions
 * from the route subtree to one `errorComponent`, so the boundary needs a
 * discriminant. Without one, a crash inside the members table would be
 * reported as "unknown industry" — a wrong answer that reads as a correct one
 * (plan §1.4 · error §6 · AD-9).
 */

import { errorHasKind } from '@/lib/errors/error-has-kind';

/** Discriminant, so a catch site does not depend on `instanceof` surviving a bundler. */
const INVALID_AREA_PARAM = 'invalid-area-param';

export class InvalidAreaParamError extends Error {
  public readonly kind = INVALID_AREA_PARAM;

  public constructor() {
    super('INVALID_AREA_ID');
    this.name = 'InvalidAreaParamError';
  }
}

/**
 * Not a type predicate: a true result may describe the CAUSE of the wrapper
 * that was passed in, not the wrapper itself.
 */
export function isInvalidAreaParamError(error: unknown): boolean {
  return errorHasKind(error, INVALID_AREA_PARAM);
}
